<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" class="px-5" PANNELS>
                <v-card NotificationPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">extension</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">
                              {{ i18n['app_account_settings'] }}
                            </div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">
                              {{ i18n['setup_your_app_account_settings'] }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                            <v-card>
                              <v-tabs
                                v-model="tab"
                                background-color="transparent"
                                color="basil"
                                grow
                              >
                                <v-tab
                                  v-for="account in accounts"
                                  :key="account.id"
                                >
                                  {{ account.app.name }}
                                </v-tab>
                              </v-tabs>

                              <v-tabs-items v-model="tab">
                                <v-tab-item
                                  v-for="account in accounts"
                                  :key="account.id"
                                >
                                  <v-card
                                    flat
                                  >
                                    <v-card-text>
                                      <v-row class="align-center">
                                        <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'}`">
                                          <v-card>
                                            <v-card-text>
                                              <v-row class="align-center">
                                                <v-col cols="12" md="8" :class="`${arabic?'arFont':'enFont'}`">
                                                  <v-row class="align-center">
                                                    <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                                                      <v-avatar v-if="account.store_logo">
                                                        <img
                                                          :src="account.store_logo"
                                                          alt="account.store_title"
                                                        >
                                                      </v-avatar>
                                                    </v-col>
                                                    <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} font-weight-bold`">
                                                      {{ account.store_title }}
                                                    </v-col>
                                                    <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                                                      <v-btn color="primary" @click="openLink(account.store_url)">
                                                        {{ i18n['open_link'] }}
                                                      </v-btn>
                                                    </v-col>
                                                    <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                                                      <div>{{i18n['products_count']}}: {{ account.app_account_products_count }}</div>
                                                      <div>{{i18n['orders_count']}}: {{ account.app_account_orders_count }}</div>
                                                    </v-col>
                                                  </v-row>
                                                </v-col>
                                                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'}`">
                                                  <img
                                                    width="100%"
                                                    src="/zidlogo.png"
                                                    alt="account.store_title"
                                                  >
                                                </v-col>
                                              </v-row>
                                            </v-card-text>
                                          </v-card>
                                        </v-col>
                                        <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'}`">
                                          <v-row class="align-center">
                                            <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                                              <v-switch
                                                v-model="account.auto_sync_orders"
                                                inset
                                                @change="updateAccount(account)"
                                                :label="i18n['auto_sync_orders']"
                                              ></v-switch>
                                            </v-col>
                                            <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                                              <v-switch
                                                v-model="account.auto_sync_products"
                                                inset
                                                @change="updateAccount(account)"
                                                :label="i18n['auto_sync_products']"
                                              ></v-switch>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                      </v-row>
                                    </v-card-text>
                                  </v-card>
                                </v-tab-item>
                              </v-tabs-items>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
export default {
  components: { Paging },
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      firstPanel:true,
      secondPanel:false,
      selectedPanel:'firstPanel',
      subitems:[
        {
          text:'الدعم',
          icon:'support_agent',
          value:'firstPanel'
        },
        {
          text:'المقترحات',
          icon:'add_box',
          value:'secondPanel'
        },
      ],
      text:null,
      accounts:[],
      tab: null,
    }
  },
  methods: {
    openLink(url){
      window.open(url, '_blank')
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}` + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    buildFilter(){
      let filter = ``
      return filter
    },
    async filterLeads(){
      await this.loadResource()
    },
    firstLoad(){
      if(this.user) {
      }
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path + '?' + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        }
        this.loading = false
        res()
      })
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    },
    async updateAccount(account){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('putResource', {resource:'/user-app-accounts/' + account.id, value:account})
        await this.loadAppAccounts()
        this.loading = false
        res()
      })
    },
    async loadAppAccounts() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        this.accounts = await this.$store.dispatch('getResource', {resource:'/user-app-accounts'})
        this.loading = false
        res()
      })
    },
    async init(){
      this.setResourceName()
      await this.loadAppAccounts()
      
    }

  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications
    },
  },
  async created(){
    await this.init()
  },
}
</script>

<style>

</style>